import React, { useState } from 'react'
import { ReactComponent as Copy } from '../../../assets/promptIcons/copy.svg';
import { Button } from '../../common';
import { handleCopy } from '../../../utils/Helper';

function GptPrompt({ promptData }) {
    const [copied, setCopied] = useState(false);
    
    return (
        <div className='max-w-7xl  m-auto flex flex-col gap-3 bg-white rounded-[8px] px-4 md:px-8 py-10'>
            <h3 className='text-[40px] font-semibold text-left text-primary'>{promptData?.title}</h3>
            <div className='w-full flex flex-wrap gap-2'>
                {promptData?.tags?.map(tag => (<div className='rounded-full py-1 px-4 bg-[#F2F4F7]'>
                    {tag}
                </div>))}
            </div>
            <p className='text-f16 text-left text-secondary'>{promptData?.description}</p>
            <p className='text-f24 font-semibold text-left text-primary'>The Prompt</p>
            <div className='bg-slate text-left min-h-[100px] border border-[#9FA4A4] shadow-[0px_32px_64px_-12px_rgba(16,24,40,0.14)] rounded-[16px] p-5'>
                <div className=' text-f16 text-left text-[#012234] font-bold'>
                    <p dangerouslySetInnerHTML={{ __html: promptData?.prompt }} />
                </div>
                <div className='flex justify-end mt-2'>
                    <Button onClick={() => handleCopy(promptData?.prompt, setCopied)} classes="flex justify-center items-center gap-2 text-[#3C4848] font-semibold border border-[#3C4848] bg-transparent text-[14px] w-[152px] h-[36px] rounded-[4px]">
                        <Copy />{copied ? "Copied!" : "Copy Prompt"}
                    </Button>
                </div>
            </div>
            {/* <p className='text-f24 font-bold text-primary'>Example</p>
            <div className='bg-slate text-left min-h-[100px]'>
                <div className='sometype-mono text-f16 text-left text-secondary p-8 font-bold'>
                    <p dangerouslySetInnerHTML={{ __html: promptData?.example }} />
                </div>
            </div> */}
            {/* <div className='w-full flex flex-wrap gap-2'>
                {
                    promptData?.tags?.map((tag) => (
                        <div className='bg-lightWarning rounded-[16px] px-2 py-[2px]'>
                            <p className='text-f12 font-semibold text-link'>{tag}</p>
                        </div>
                    ))
                }
            </div> */}
        </div>
    )
}

export default GptPrompt